import { Outlet } from 'react-router';
import { selectRefreshToken } from '../../../store/user/selectors';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { LOGIN_PATH, ROUTER_BASE_PATH } from '../../../constants';
import { StyledHeader } from '../styled';
import {
  StyledWrapper,
  StyledSubHeader,
  StyledInner,
  StyledHeaderContainer,
} from './styled';

const Layout = () => {
  const token = useSelector(selectRefreshToken);

  useEffect(() => {
    if (!token) {
      window.location.href = `${LOGIN_PATH}?redirect=${ROUTER_BASE_PATH}/apps`;
    }
  }, [token]);

  if (!token) {
    return null;
  }
  return (
    <StyledWrapper>
      <StyledHeaderContainer>
        <StyledHeader>My Apps</StyledHeader>
        <StyledSubHeader>
          Manage your API keys and monitor your usage
        </StyledSubHeader>
      </StyledHeaderContainer>
      <StyledInner>
        <Outlet />
      </StyledInner>
    </StyledWrapper>
  );
};

export default Layout;
